<template>
  <footer class="footer">
    <p class="text-muted">&copy; APImetrics Inc, 2024.</p>
    <p>
      <a href="https://apimetrics.io/subscription/" rel="_blank">Terms &amp; Conditions</a> -
      <a href="https://apimetrics.io/privacy/" rel="_blank">Privacy</a> -
      <a href="https://apimetrics.io/tos/" rel="_blank">Terms of Service</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
};
</script>
